import { render, staticRenderFns } from "./PriceListGeneral.vue?vue&type=template&id=2312fe90&scoped=true&"
import script from "./PriceListGeneral.vue?vue&type=script&lang=js&"
export * from "./PriceListGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2312fe90",
  null
  
)

export default component.exports